import React from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import {HomePage} from 'src/pages'
import {config} from 'src/shared/config'

import {RedirectToHomePage} from '../pages/route'

export const Routes: React.FC = () => {
  return (
    <BrowserRouter basename={config.basename}>
      <Switch>
        <Route component={HomePage} exact path="/v1/auth/" />
        <Route component={RedirectToHomePage} path="/v1/auth/:sharingKey" />
        <Route component={HomePage} exact path="/" />
        <Route component={RedirectToHomePage} path="/:sharingKey?" />
      </Switch>
    </BrowserRouter>
  )
}
